import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingPilcrow: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 10A5 5 0 0 1 5 0h11v3.5h-2V16h-3.5V3.5h-2V16H5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingPilcrow
